import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
import { OpenSizingVariationHelper } from "./OpenSizingVariationHelper";
import { OpenSizingVariationInput } from "./OpenSizingVariationInput";
import { OpenSizingVariationLabel } from "./OpenSizingVariationLabel";
/**
 * @trackcomponent
 * @supersededBy "@faire/web/slate/QuantityPicker/QuantityPicker#QuantityPicker"
 */ var QuantityPickerBase = function(param) {
    var variation = param.variation, className = param.className, onChange = param.onChange, isFirst = param.isFirst;
    return /*#__PURE__*/ _jsxs(Container, {
        className: className,
        $isFirst: isFirst,
        children: [
            /*#__PURE__*/ _jsx(LabelContainer, {
                children: /*#__PURE__*/ _jsxs(FullWidthColumn, {
                    children: [
                        /*#__PURE__*/ _jsx(OpenSizingVariationLabel, {
                            variation: variation
                        }),
                        /*#__PURE__*/ _jsx(OpenSizingVariationHelper, {
                            variation: variation
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(InputContainer, {
                children: /*#__PURE__*/ _jsx(OpenSizingVariationInput, {
                    variation: variation,
                    onChange: onChange
                })
            })
        ]
    });
};
export var QuantityPicker = observer(QuantityPickerBase);
var Container = styled(Row).attrs({
    justify: "space-between",
    align: "center"
}).withConfig({
    componentId: "sc-ab23351a-0"
})([
    "width:100%;padding:",
    ";border:1px solid ",
    ";margin-top:",
    ";"
], getSpacing(5, 0), Core.border.muted, function(param) {
    var $isFirst = param.$isFirst;
    return $isFirst ? "unset" : "-1px";
});
var LabelContainer = styled(Row).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-ab23351a-1"
})([
    "width:100%;margin-left:",
    ";margin-right:",
    ";"
], getSpacing("2x"), getSpacing("2x"));
var FullWidthColumn = styled(Column).withConfig({
    componentId: "sc-ab23351a-2"
})([
    "width:100%;"
]);
var InputContainer = styled(Row).attrs({
    justify: "flex-end",
    align: "center"
}).withConfig({
    componentId: "sc-ab23351a-3"
})([
    "margin-right:",
    ";width:140px;",
    "{width:150px;}"
], getSpacing("2x"), responsiveMediaQueries.mobile);
